import * as Zod from 'zod';

import { translate } from 'utils/i18n';
import { INotificationOffsetScale, INotificationTargets } from 'graphql/types';
import { EScoringSystemOption } from 'certificate/types';
import { extraCategoryInputValidator } from 'common/validators/extraCategory';

export function getExternalCertificateFormValidator() {
    return Zod.object({
        name: Zod.string(translate('validate.required')).nonempty(
            translate('validate.required')
        ),
        sendNotification: Zod.boolean().optional().nullable(),
        notificationOffset: Zod.coerce
            .number<number>(translate('validate.mustBeANumber'))
            .int(translate('validate.integer'))
            .nonnegative(translate('validate.zeroOrPositive'))
            .optional()
            .nullable(),
        notificationOffsetScale: Zod.enum(INotificationOffsetScale)
            .optional()
            .nullable(),
        notificationTargets: Zod.array(Zod.enum(INotificationTargets))
            .transform((val) => (!val.length ? undefined : val))
            .optional()
            .nullable(),
        requiresValidation: Zod.boolean().optional().nullable(),
        reference: Zod.string().optional().nullable(),
        scoring: Zod.object({
            score: Zod.coerce
                .number<number>(translate('validate.mustBeANumber'))
                .nonnegative(translate('validate.zeroOrPositive'))
                .optional()
                .nullable(),
            scoringSystemId: Zod.string().optional().nullable(),
        })
            .refine(
                (data) => {
                    // scoringSystemId is required only if score has a value
                    if (!!data.score) {
                        return (
                            !!data.scoringSystemId &&
                            data.scoringSystemId !==
                                EScoringSystemOption.NoScoringSystem
                        );
                    }

                    return true;
                },
                {
                    message: translate('validate.required'),
                    path: ['scoringSystemId'],
                }
            )
            // If score is not set, remove the scoring object
            .transform((val) => (!val.score ? undefined : val))
            .optional()
            .nullable(),
        extraCategories: extraCategoryInputValidator(true).optional(),
    });
}
